document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.Index_global_reviews_slider').forEach((slider) => {

    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      // freeMode: true,

      navigation: {
        nextEl: slider.closest('.Index_global_reviews').querySelector('.Index_global_reviews_next'),
        prevEl: slider.closest('.Index_global_reviews').querySelector('.Index_global_reviews_prev')
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        750: {
          slidesPerView: 'auto',
          spaceBetween: 16
        }
      },

      on: {
        init: function () {

          slider.querySelectorAll('video').forEach(video => {

            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.autoplay = true;

            const playPromise = video.play();

            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }

          });

        }
      }
    });

    const navigation = slider
      .closest('.Index_global_reviews')
      .querySelector('.Index_global_reviews_navigation');

    if (navigation) {

      const toggleNavigation = () => {

        if (swiper.isLocked) {
          navigation.style.display = 'none';
        } else {
          navigation.style.display = 'flex';
        }

      };

      toggleNavigation();

      swiper.on('resize', toggleNavigation);
      swiper.on('update', toggleNavigation);
      swiper.on('lock', toggleNavigation);
      swiper.on('unlock', toggleNavigation);

    }

  });

});